export default {
  tabs: {
    accounts: "帳戶",
    report_config: "報告設定",
    general: "一般",
    billing_notifications: "帳單與通知",
    privacy: "隱私",
    help: "幫助",
    about: "關於",
  },
  general: {
    title: "一般設定",
    displaySettings: "顯示設定",
    theme: "主題",
    primaryColor: "主要顏色",
    languageSettings: "語言設定",
    language: "語言",
    otherSettings: "其他設定",
    timezone: "時區",
    selectTimezone: "選擇時區",
    dateFormat: "日期格式",
    selectDateFormat: "選擇日期格式",
    numberFormat: "數字格式",
    selectNumberFormat: "選擇數字格式",
    englishFormat: "英文格式",
    europeanFormat: "歐洲格式",
    spaceFormat: "空格格式",
  },
  account: {
    title: "帳戶設定",
    subtitle: "管理您的個人資訊、安全性設定和帳戶偏好",
    edit: "編輯",
    save: "儲存變更",
    cancel: "取消",
    profile: {
      title: "個人資訊",
      name: "姓名",
      email: "電子郵箱地址",
      email_tip: "電子郵箱地址無法更改",
      company: "公司",
      phone: "電話",
      phone_invalid: "電話號碼格式無效",
      bio: "個人簡介",
      website: "網站",
      website_invalid: "網站 URL 格式無效",
      location: "位置",
      position: "職位",
      validation_error: "表單驗證失敗，請檢查您的輸入",
      change_avatar: "更換頭像",
      remove: "移除頭像",
      save_success: "個人資料更新成功",
      avatar_format_error: "您只能上傳 JPG/PNG 檔案！",
      avatar_size_error: "圖片必須小於 2MB！",
      avatar_upload_error: "頭像上傳失敗",
      avatar_format_tip: "JPG/PNG 格式",
      avatar_size_tip: "最大檔案大小：2MB",
      name_placeholder: "輸入您的姓名",
      company_placeholder: "輸入您的公司",
      phone_placeholder: "輸入您的電話號碼",
      bio_placeholder: "告訴我們關於您的資訊",
      website_placeholder: "https://example.com",
      location_placeholder: "輸入您的位置",
      position_placeholder: "輸入您的職位",
    },
    security: {
      password_title: "密碼設定",
      password_tip: "為了帳戶安全，建議定期更改密碼",
      change_password: "更改密碼",
      current_password: "目前密碼",
      new_password: "新密碼",
      confirm_password: "確認新密碼",
      save_password: "儲存密碼",
      password_changed: "密碼已更新",
      password_mismatch: "新密碼和確認密碼不匹配",
      password_incorrect: "目前密碼不正確",
      password_required: "請填寫所有密碼欄位",
      password_too_short: "密碼長度至少 8 個字元",
      password_change_failed: "密碼更改失敗",
      two_factor_auth_title: "雙因素認證",
      two_factor_auth: "雙因素認證",
      two_factor_auth_desc: "新增一層額外的安全性，登入時需要密碼和設備驗證碼",
      two_factor_auth_coming_soon: "功能即將推出",
      current_password_placeholder: "輸入目前密碼",
      new_password_placeholder: "輸入新密碼",
      confirm_password_placeholder: "確認新密碼",
    },
    login_activity: {
      title: "登入活動",
      manage: "管理",
      trust_device: "信任裝置",
      logout_device: "登出裝置",
      device_trusted: "裝置 {location} 已被信任",
      device_logged_out: "已從裝置 {location} 登出",
      showing_details: "顯示 {location} 的詳細資訊 - IP: {ip}, 時間: {time}",
      manage_info: "管理 {location} 的登入活動",
      login_details: "登入詳細資訊",
      ip_address: "IP 地址",
      time: "時間",
      isp: "網路服務提供商",
      bot_score: "機器人評分",
      locations: {
        current: "目前裝置",
      },
      suspicious: "可疑",
      mobile_device: "行動裝置",
      api_client: "API 客戶端",
      trusted: "已信任",
      device: "裝置",
      client: "客戶端",
      unknown: "未知",
      risk_reasons: "風險原因",
      location: "位置",
      trust_failed: "信任裝置失敗",
      show_more: "顯示更多 {0} 項",
      show_less: "顯示較少",
    },
    danger: {
      title: "危險區域",
      delete_title: "刪除帳戶",
      delete_desc: "永久刪除您的帳戶和所有相關數據。此操作無法撤銷。",
      confirm_title: "您確定要刪除帳戶嗎？",
      confirm_desc: "此操作將永久刪除您的帳戶和所有相關數據。無法撤銷。",
      confirm_email_tip: "要確認刪除，請輸入您的電子郵箱地址：",
      confirm_email_placeholder: "輸入您的電子郵箱地址",
      confirm: "確認刪除",
      cancel: "取消",
      delete_account: "刪除帳戶",
      delete_success: "帳戶刪除成功",
      email_mismatch: "電子郵箱地址不匹配。請輸入正確的電子郵箱地址。",
    },
  },
  privacy: {
    title: "隱私設定",
    privacyPolicyAgreement: "隱私政策協議",
    privacyPolicyAgreementDesc: "當您在註冊帳戶時已同意我們的隱私政策",
    privacyPolicyAgreementInfo: "隱私政策協議無法撤銷",
  },
  reportConfig: {
    colorPicker: {
      title: "顏色選擇器",
    },
    currencyName: {
      EUR: "歐元 (€)",
      USD: "美元 ($)",
      GBP: "英鎊 (£)",
    },
    fetchDataFailed: "獲取數據失敗",
    configSelection: "設定選擇",
    default: "預設",
    professional: "專業",
    simple: "簡易",
    custom: "自訂",
    exportType: "匯出類型",
    upgradeToUnlock: "升級以解鎖此功能",
    commonSettings: "常用設定",
    tableHeaderFont: "表格標題字體",
    tableCellFont: "表格儲存格字體",
    textFont: "文字字體",
    textColor: "文字顏色",
    tableHeaderBg: "表格標題背景",
    selectColor: "選擇顏色",
    dataFormat: "數據格式",
    selectFormat: "選擇格式",
    titleFontSize: "標題字體大小",
    watermarkFontSize: "浮水印字體大小",
    titleColor: "標題顏色",
    premiumTitleColorActive: "高級標題顏色已啟用",
    blue: "藍色",
    red: "紅色",
    displayFields: "顯示欄位",
    showDate: "顯示日期",
    showContact: "顯示聯絡人",
    showEmail: "顯示電子郵箱",
    showTitle: "顯示標題",
    showEmissionDetails: "顯示排放詳細資訊",
    showSummary: "顯示摘要",
    showTotalDistance: "顯示總距離",
    showProductionEmission: "顯示生產排放",
    showTransportEmission: "顯示運輸排放",
    showTotalEmission: "顯示總排放",
    showTax: "顯示稅費",
    showCompliance: "顯示合規聲明",
    privacyFields: "隱私欄位",
    hideCompanyName: "隱藏公司名稱",
    hideContact: "隱藏聯絡人",
    hideEmail: "隱藏電子郵箱",
    hideLogo: "隱藏公司標誌",
    hideWeight: "隱藏重量",
    premiumFeatures: "高級功能",
    generalConfig: "一般設定",
    language: "語言",
    selectLanguage: "選擇語言",
    currency: "貨幣",
    selectCurrency: "選擇貨幣單位",
    showLogo: "顯示標誌",
    companyLogo: "公司標誌",
    logoSupportFormat: "支援格式：JPG, PNG, GIF, WEBP, 最大 2MB",
    showCompany: "顯示公司",
    companyName: "公司名稱",
    enterCompanyName: "輸入公司名稱",
    customContact: "自訂聯絡人",
    enterContact: "輸入聯絡人",
    customEmail: "自訂電子郵箱",
    enterEmail: "輸入電子郵箱",
    customCompliance: "自訂合規聲明",
    enterCompliance: "輸入合規聲明",
    customFooter: "自訂頁腳",
    excelFontStyle: "Excel 中的字體樣式由預設設定控制",
    footerPlaceholder: "例如：TaxEcoBit CBAM 合規報告",
    showEmissionChart: "顯示排放圖表",
    pdfAdvancedFeatures: "PDF 進階功能",
    removeWatermark: "移除浮水印",
    showSignatureArea: "顯示簽名區域",
    removeQRCode: "移除 QR 碼",
    logoPosition: "標誌位置",
    selectPosition: "選擇位置",
    topLeft: "左上",
    topRight: "右上",
    borderStyle: "邊框樣式",
    none: "無",
    solid: "實線",
    premiumTitleColor: "高級標題顏色",
    customTableHeaderBg: "自訂表格標題背景",
    customWatermark: "自訂浮水印",
    enterWatermark: "輸入浮水印內容",
    inviteText: "邀請文字",
    enterInviteText: "輸入邀請文字",
    excelAdvancedFeatures: "Excel 進階功能",
    columnWidth: "欄寬",
    cellBackground: "儲存格背景",
    mergeHeader: "合併標題",
    enableFilter: "啟用篩選",
    addDigitalSignature: "新增數位簽名",
    signatureContent: "簽名內容",
    enterSignature: "輸入簽名內容",
    premiumFeaturesDesc: "這些高級功能可以提升您報告的專業性",
    upgradeMessage: "升級到高級版以解鎖語言切換、自訂標誌和其他獨家功能",
    lightGray: "淺灰色",
    darkGray: "深灰色",
    messages: {
      excelExportRequiresPro: "Excel 匯出需要專業版訂閱，已切換為 PDF",
      logoUploadFailed: "標誌上傳失敗",
      configSaveSuccess: "設定儲存成功",
      configSaveFailed: "設定儲存失敗",
      imageFileOnly: "僅支援圖片檔案！",
      imageSizeLimit: "圖片大小不得超過 2MB！",
      fileReadFailed: "檔案讀取失敗",
    },
  },
  billing: {
    title: "帳單與通知",
    compliance: "合規要求",
    compliance_desc: "關鍵通知，無法停用",
    service: "服務關鍵",
    service_desc: "建議保持啟用",
    experience: "使用者體驗",
    experience_desc: "選用，可以關閉",
  },
  notification: {
    title: "通知設定",
    policy: "CBAM 政策更新",
    policy_desc: "接收歐盟 CBAM 法規的緊急變更。合規和避免罰款所必需。",
    payment: "付款失敗警報",
    payment_desc: "付款失敗時立即通知，以防止服務中斷。",
    expiry: "方案到期提醒",
    expiry_desc: "方案到期前 3 天通知。及時續訂以避免服務暫停。",
    quota: "配額警告",
    quota_desc: "當您使用 80% 的每月計算次數時發出警報。避免意外限制。",
    ticket: "支援工單更新",
    ticket_desc: "支援工單狀態變更時接收電子郵件更新。",
    referral: "推薦獎勵",
    referral_desc: "成功推薦時通知您獲得免費計算次數。",
  },
  info: {
    about_taxecobit: "關於 TaxEcoBit",
    about_taxecobit_description:
      "TaxEcoBit 是一款專為歐盟中小企業設計的工具，用於簡化 CBAM 碳排放報告和合規。準確率超過 90%，可快速進行計算和產生報告，幫助降低罰款風險（€1K–€10K）。",
    our_vision: "我們的願景",
    our_vision_description:
      "我們旨在通過創新解決方案賦予歐盟中小企業無縫的 CBAM 合規能力，推動可持續增長並支援 2026 年的可持續發展目標。",
    contact_us: "聯絡我們",
    follow_us: "關注我們：",
    version_info: "版本資訊",
    version: "版本",
    last_updated: "最後更新",
    license: "授權",
    copyright: "© 2025 TaxEcoBit。保留所有權利。",
  },
};
